// extracted by mini-css-extract-plugin
export var badge = "cs_jQ";
export var percentage = "cs_jR";
export var sliderContainer = "cs_jS";
export var sliderSegment = "cs_jV";
export var sliderThumb = "cs_jW";
export var sliderThumbDisabled = "cs_jX";
export var sliderTrack = "cs_jT";
export var statusRow = "cs_jP";
export var titleLabel = "cs_jN";
export var titleRow = "cs_jM";
export var wrapper = "cs_bF";